/**
 * Wonderly PDP gallery — static featured image + thumbnail switching.
 * Keeps Dawn media-gallery.js; animates viewer height on image change.
 */
(function () {
  const HEIGHT_TRANSITION =
    'height var(--duration-medium, 300ms) var(--ease-out-slow, cubic-bezier(0, 0, 0.3, 1))';

  function measureActiveSlideHeight(viewer) {
    const active = viewer.querySelector('.product__media-item.is-active');
    if (!active) return 0;
    return Math.ceil(active.getBoundingClientRect().height);
  }

  function setViewerHeight(viewer, height, animate) {
    if (height <= 0) return;

    if (!animate) {
      viewer.style.transition = 'none';
    }

    viewer.style.height = `${height}px`;

    if (!animate) {
      viewer.offsetHeight;
      viewer.style.transition = HEIGHT_TRANSITION;
    }
  }

  function updateViewerHeight(viewer, animate) {
    const active = viewer.querySelector('.product__media-item.is-active');
    if (!active) return;

    const apply = () => {
      requestAnimationFrame(() => {
        const height = measureActiveSlideHeight(viewer);
        setViewerHeight(viewer, height, animate);
      });
    };

    const img = active.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener('load', apply, { once: true });
      img.addEventListener('error', apply, { once: true });
      return;
    }

    apply();
  }

  function patchMediaGallery(gallery) {
    if (!gallery || gallery.dataset.wonderlyPdpGallery === 'true') return;
    gallery.dataset.wonderlyPdpGallery = 'true';

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbnails) return;

    viewer.style.transition = HEIGHT_TRANSITION;

    const syncActiveSlide = (animate = true) => {
      const activeThumb = thumbnails.querySelector('[data-target] button[aria-current="true"]');
      const mediaId = activeThumb?.closest('[data-target]')?.dataset.target;
      if (!mediaId) return;

      viewer.querySelectorAll('[data-media-id]').forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });

      const list = viewer.querySelector('.product__media-list');
      if (list) list.scrollLeft = 0;

      updateViewerHeight(viewer, animate);
    };

    thumbnails.querySelectorAll('[data-target] button').forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          window.requestAnimationFrame(() => syncActiveSlide(true));
        },
        { passive: true }
      );
    });

    viewer.querySelectorAll('[data-media-id]').forEach((slide) => {
      const observer = new MutationObserver(() => {
        if (slide.classList.contains('is-active')) {
          updateViewerHeight(viewer, true);
        }
      });
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => updateViewerHeight(viewer, false), 120);
    });

    syncActiveSlide(false);
  }

  function initWonderlyPdpGalleries(root = document) {
    root.querySelectorAll('.wonderly-pdp media-gallery').forEach(patchMediaGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWonderlyPdpGalleries());
  } else {
    initWonderlyPdpGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWonderlyPdpGalleries(event.target);
  });
})();
